import React from "react";

const NewFeedSingleImage: React.FC<{
  post: any;
  onOpenPostModal: (postId: string) => void;
}> = ({ post, onOpenPostModal }) => {
  return (
    <div onClick={() => onOpenPostModal(post.post_id)}>
      <div className="w-full max-h-[500px] relative  overflow-hidden mt-2">
        <div
          className="absolute inset-0 bg-cover bg-center bg-black opacity-50 blur-3xl"
          style={{
            backgroundImage: `url("${post?.post_attachments[0]?.attachment_thumbnail_image_file_src}")`,
          }}
        />

        <img src={post.post_attachments[0].attachment_media_image_file_src} alt="Post" className="relative z-10  w-full h-auto max-h-[500px] object-contain" loading="lazy" />
      </div>
    </div>
  );
};

export default NewFeedSingleImage;

